import React from 'react'
import './index.css'
import './App.scss'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './index.css'
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import { store } from './store/store';
import ScrollControl from './utils/ScrollControl'
import ScrollToHash from './utils/ScrollToHash'


createRoot(document.getElementById('root')).render(
  <StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <ScrollControl />
        <ScrollToHash />
        <App />
      </BrowserRouter>
    </Provider>
  </StrictMode>
);
